import { ApiWrapper } from '../../types/utils';
import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { OnlyOfficeFile } from '../../types/onlyOffice';

export class JOnlyOfficeApi extends JBaseApi {
    public getFile(idFile: number, hash?: string): Promise<ApiWrapper<OnlyOfficeFile>> {
        return this.network.post({ o: 'onlyOffice', f: 'getFile', idFile, hash } as OF);
    }

    public deleteFile(idFile: number, withParent?: boolean): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({ o: 'onlyOffice', f: 'deleteFile', idFile, withParent } as OF);
    }

    public createVersion(idFile: number): Promise<ApiWrapper<boolean>> {
        return this.network.post({ o: 'onlyOffice', f: 'createVersion', idFile } as OF);
    }
}
